import { formatMoney } from '@/components/cart/utils.js';

export { formatMoney } from '@/components/cart/utils.js';

const PAIR = 2;

export function formatPrice(product, country, quantity = 1) {
  if(!product) {
    return {};
  }

  const prices = product.price || [];
  if(country && prices.length) {
    const price = Object.assign({}, prices.find(price => (price.currencyCode || '').toLowerCase() === country.currency) || {});

    if(!price || !price.price) {
      return {};
    }

    price.symbol = country.currencySymbol;
    price.currency = country.currency.toUpperCase();

    if(quantity > 1) {
      price.price *= quantity;
      price.sale *= quantity;
      price.clearance *= quantity;
      price.retail *= quantity;
    }

    if(!product.onSale) {
      price.sale = null;
    }
    if(!product.onClearance) {
      price.clearance = null;
    }

    price.final = Math.min(...[price.price, price.sale, price.clearance].filter(v => v));
    price.saving = price.price - price.final;
    price.priceFormatted = formatMoney(country.currencySymbol, price.price);
    price.finalFormatted = formatMoney(country.currencySymbol, price.final);
    price.savingFormatted = formatMoney(country.currencySymbol, price.saving);

    if(price.retail) {
      price.retailSaving = price.retail - price.final;
      price.retailFormatted = formatMoney(country.currencySymbol, price.retail);
      price.retailSavingFormatted = formatMoney(country.currencySymbol, price.retailSaving);
    }

    if(quantity === PAIR) {
      price.pair = true;
    }

    return price;
  }
  return {};
}
